import React from 'react'

import { bemJoin } from 'bem-join'

import { useIntl } from '@app/intl/Intl'
import { InputField } from '@app/lib/fields/InputField/InputField'
import { AmountInput } from '@app/lib/inputs/TextInput/AmountInput'
import { Text } from '@app/lib/typography/Text/Text'
import { ClientCountInput } from '@app/modules/CourtCases/Components/CourtCaseInvoicingForm/Components/InvoicingBasicSection/ClientCountInput/ClientCountInput'
import { CourtCaseNameSelect } from '@app/modules/CourtCases/Components/CourtCaseInvoicingForm/Components/InvoicingBasicSection/CourtCaseNameSelect/CourtCaseNameSelect'
import { InvoiceTypeChoiceField } from '@app/modules/CourtCases/Components/CourtCaseInvoicingForm/Components/InvoicingBasicSection/InvoiceTypeChoiceField/InvoiceTypeChoiceField'
import { LegalPositionSelect } from '@app/modules/CourtCases/Components/CourtCaseInvoicingForm/Components/InvoicingBasicSection/LegalPositionSelect/LegalPositionSelect'
import { VatSelect } from '@app/modules/CourtCases/Components/CourtCaseInvoicingForm/Components/InvoicingBasicSection/VatSelect/VatSelect'
import { useInvoicingFeeTablesContext } from '@app/modules/CourtCases/Components/CourtCaseInvoicingForm/Components/InvoicingFeeTablesContext/InvoicingFeeTablesContext'

import '../../styles.scss'

export const InvoicingBasicSection = () => {
  const b = bemJoin('court-case-invoicing-form')
  const { formatMessage } = useIntl()
  const { setCourtCaseFee } = useInvoicingFeeTablesContext()

  return (
    <div className={b('section')}>
      <Text size={'ml'} weight={'bold'}>
        {formatMessage({ id: 'CourtCases.Invoicing.Section.Basics.Title' })}
      </Text>
      <div className={b('fields')}>
        <CourtCaseNameSelect />
        <InvoiceTypeChoiceField />
        <InputField
          name='DisputeValue'
          label={formatMessage({ id: 'CourtCases.Invoicing.Field.DisputeValue' })}
          rules={{
            pattern: {
              value: /^[0-9]+(\.[0-9]{1,2})?$/,
              message: formatMessage({ id: 'CourtCases.Invoicing.Field.Error.ValidValue' })
            }
          }}
          render={({ inputProps }) => {
            return (
              <AmountInput
                inputProps={{
                  ...inputProps,
                  onChange: (value) => {
                    inputProps.onChange(value)
                    setCourtCaseFee()
                  }
                }}
                unit={'€'}
                className={b('field', { md: true })}
              />
            )
          }}
        />
        <ClientCountInput />
        <VatSelect />
        <LegalPositionSelect />
      </div>
    </div>
  )
}
